export default {
  title: 'Add a Patient',
};
